// import * as React from 'react';
// import getHtmlDataSet from 'Utils/GetHtmlDataSet';
// import postData from 'Utils/PostData';
// import { NavDropdown } from 'react-bootstrap'
// import { logout } from "Store/UserInfo/Actions";
// import { bindActionCreators } from "redux";
// import { connect } from "react-redux";
// // Assets
// import fontawesome from '@fortawesome/fontawesome';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUserCircle, faCheck } from '@fortawesome/free-solid-svg-icons'
// import { modeRoutes } from "Store/UserInfo/Actions";


// fontawesome.library.add(faUserCircle, faCheck);
// // Components

// class InstructorProfileButton extends React.Component {
//     // setUserMode(mode) {
//     //     postData(
//     //         '/user/switch-mode/?format=json',
//     //         {
//     //             new_mode: mode
//     //         },
//     //         'application/x-www-form-urlencoded')
//     //         .then(() => { window.location.reload() })
//     //         .catch(err => log.error(err));
//     // }

//     constructor(props) {
//         super(props);
//         this.state = { "mode": "I" };
//     }

//     handleModeChange(mode, token) {
//         log.log("mode is new ", mode);
//         let error = "Can't switch mode";
//         this.state = { "mode": mode };
//         if (this.props.mode !== mode) {
//             this.props.actions.modeRoutes(mode, token);
//         }
//     }

//     render() {
//         //     return <li className='nav-item dropdown'>
//         //         <a
//         //             className='nav-link dropdown-toggle'
//         //             href='#'
//         //             id='navbarDropdown'
//         //             role='button'
//         //             data-toggle='dropdown'
//         //             aria-haspopup='true'
//         //             aria-expanded='false'>
//         //             {/* {getHtmlDataSet().fullName} */}
//         //             Arnab
//         //         </a>
//         //         <div className='dropdown-menu' aria-labelledby='navbarDropdown'>
//         //             {/* {getHtmlDataSet().isInstructor === 'True' ? (
//         //                 getHtmlDataSet().mode === 'I' ?
//         //                     <a className='dropdown-item' href='#' onClick={() => this.setUserMode('S')}>View as Student</a>
//         //                     :
//         //                     <a className='dropdown-item' href='#' onClick={() => this.setUserMode('I')}>View as Instructor</a>
//         //             ):null} */}
//         //             <a className='dropdown-item' href='#'>Profile</a>
//         //             <div className='dropdown-divider'></div>
//         //             <a className='dropdown-item' href='/accounts/logout/'>Sign Out</a>
//         //         </div>
//         //   </li>
//         const userName = this.props.title
//         return (
//             <NavDropdown
//                 style={{ paddingLeft: "0em", paddingRight: "0.5em" }}
//                 title={
//                     <>
//                         <FontAwesomeIcon icon="user-circle" style={{ fontSize: "1.8em" }} className={'d-none d-lg-inline-block'} />
//                         <span className="d-lg-none" style={{ fontSize: 21 }}> Account </span>
//                     </>
//                 }
//                 id="basic-nav-dropdown">

//                 <NavDropdown.Item href="#">{userName}</NavDropdown.Item>
//                 <NavDropdown.Divider />
//                 <NavDropdown.Item href="/" onClick={()=>this.props.actions.logout()}>Logout</NavDropdown.Item>
//             </NavDropdown>
//         );
//     }
// };

// const mapDispatchToProps = (dispatch) => ({
//     actions: bindActionCreators(
//         {
//             logout,
//             modeRoutes,
//         },
//         dispatch
//     ),
// });

// // export default connect(null, mapDispatchToProps)(InstructorProfileButton);
// export default InstructorProfileButton;

import React, { useEffect, useRef, useState } from "react";
import { NavDropdown } from "react-bootstrap";
import { logout } from "Store/UserInfo/Actions";
import { useDispatch, useSelector } from "react-redux";

import fontawesome from "@fortawesome/fontawesome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faCheck } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import httpService from 'services/httpService';
import { initializeStatistics, removeEventListeners } from "Utils/statistics/active_hrs_stats";
import log from "loglevel";
fontawesome.library.add(faUserCircle, faCheck);

const InstructorProfileButton = () => {
    const [mode, setMode] = useState("I");
    const dispatch = useDispatch();
    const { username, email,userId } = useSelector((state) => state.userInfo);
    if(email){
        localStorage.setItem("email",email);
    }
    const logoutButtonRef = useRef(null);

    // const handleModeChange = (mode_, token) => {
    //     log.log("Mode is new: ", mode_);
    //     let error = "Can't switch mode";
    //     setMode(mode_);
    //     if (mode !== mode_) {
    //         dispatch(modeRoutes(mode_, token));
    //     }
    // }

    useEffect(() => {
        const fetchData = async () => {
            initializeStatistics();
    
            try {
                const response = await httpService.get(`/accounts/api/profile/?user=${userId}`);
                log.log({ response });
                const profiles = response.data;
                let this_profile = profiles?.find(f => f.user === userId);
                log.log({ this_profile, profiles});
                const UserName=this_profile?.first_name+" "+this_profile?.last_name;
                localStorage.setItem("UserName",UserName);
                
            } catch (error) {
                log.error("Error fetching data:", error);
            }
        };
    
        fetchData();
    
        return removeEventListeners;
    }, []);
    

    return (
        <>
            <NavDropdown
                className="size16"
                style={{ paddingLeft: "0em", paddingRight: "0.5em" }}
                title={
                    <>
                        <FontAwesomeIcon icon="user-circle" style={{ fontSize: "25px" }} className={'d-none d-lg-inline-block'} />
                        <span className="mx-1 size16 weight500">{email ? email : username}</span>
                        <span className="d-lg-none" style={{ fontSize: 21 }}> Account </span>
                    </>
                }
            >
                <NavDropdown.Item as={Link} to={`/profile`}>Profile</NavDropdown.Item>
                {/* <NavDropdown.Divider /> */}
                <NavDropdown.Item as={Link} to={`/`} onClick={() => {
                    log.log("Loging out user");
                    logoutButtonRef.current.click();
                    dispatch(logout());
                    removeEventListeners();
                }}>Logout</NavDropdown.Item>
            </NavDropdown>
            <div ref={logoutButtonRef} id="logoutUser" style={{display: "none"}}></div>
        </>
    );
}

export default InstructorProfileButton;
